import LinkOutIconPath from "@ingka/ssr-icon/paths/link-out";

export default LinkOutIconPath;
